import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import VueCompositionAPI from '@vue/composition-api'
import PortalVue from 'portal-vue'
/** Plugins **/
import '@/plugins/axios'
import vuetify from '@/plugins/vuetify'
import ability from '@/plugins/ability'
import '@/plugins/vee-validate'
import { abilitiesPlugin } from '@casl/vue'
import Dayjs from 'vue-dayjs'
import dayjs from 'dayjs'
import Croppa from 'vue-croppa'
import CountryFlag from 'vue-country-flag'
import i18n from '@/plugins/i18n'
import VueTheMask from 'vue-the-mask'
/** Filters **/
import customParseFormat from 'dayjs/plugin/customParseFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import isTomorrow from 'dayjs/plugin/isTomorrow'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import weekday from 'dayjs/plugin/weekday'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/de'
import 'dayjs/locale/hr'
import 'dayjs/locale/ru'
import 'dayjs/locale/es'
import 'dayjs/locale/tr'
import localeData from 'dayjs/plugin/localeData'
import Vue2Filters from 'vue2-filters'
/** Assets **/
import '@/scss/app.scss'
/** Utilities **/
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
/** Component **/
import App from '@/App.vue'

Vue.config.productionTip = false

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [process.env.VUE_APP_APP_DOMAIN as string | RegExp, /^\//]
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: Number(process.env.VUE_APP_SENTRY_TRACING_SAMPLE) || 1.0
  })
}

dayjs.extend(customParseFormat)
dayjs.extend(relativeTime)
dayjs.extend(isTomorrow)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)
dayjs.extend(localeData)
dayjs.extend(weekday)

dayjs.locale(i18n.locale)

vuetify.framework.lang.current = i18n.locale

Vue.use(Dayjs, {
  lang: i18n.locale
})
Vue.use(Vue2Filters)
Vue.use(abilitiesPlugin, ability)
Vue.use(VueCompositionAPI)
Vue.use(PortalVue)
Vue.use(Croppa)
Vue.component('country-flag', CountryFlag)
Vue.use(VueTheMask)

/**
 * Vue filter to round the decimal to the given place.
 * http://jsfiddle.net/bryan_k/3ova17y9/
 *
 * @param {String} value    The value string.
 * @param {Number} decimals The number of decimal places.
 */
Vue.filter('round', function (value: any, decimals: number) {
  if (!value) {
    value = 0
  }

  if (!decimals) {
    decimals = 0
  }

  value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
  return value
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
